import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import pt from 'vuetify/src/locale/pt.ts'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    themes: {
      light: {
        primary: '#EC6521',
        secondary: '#F8BD18',
        anchor: '#707070',
        success: '#118F2D',
        error: '#FF0B0B',
        blue: '#4393B6'
      },
      dark: {
        primary: '#EC6521'
      }
    }
  }
})

export default vuetify



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js